import { useMemo } from 'react';
import { getLoginCookie } from '../js/login-cookie-utility';

const useLoginCookie = () => {
  const loginJson = useMemo(() => {
    return getLoginCookie();
  }, []);

  return loginJson;
};

export default useLoginCookie;